import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "time-controller__inner" }
const _hoisted_2 = { class: "retention" }
const _hoisted_3 = {
  key: 0,
  class: "retention_row"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "retention_name" }, " 交通量データ１時間値（常設観測データ計測値）- 常設トラカン ", -1)
const _hoisted_5 = { class: "retention_time" }
const _hoisted_6 = {
  key: 1,
  class: "retention_row"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "retention_name" }, " 交通量データ１時間値（常設観測データ計測値）- CCTVトラカン ", -1)
const _hoisted_8 = { class: "retention_time" }
const _hoisted_9 = {
  key: 2,
  class: "retention_row"
}
const _hoisted_10 = { class: "retention_name" }
const _hoisted_11 = { class: "retention_time" }
const _hoisted_12 = ["value"]
const _hoisted_13 = ["value"]
const _hoisted_14 = ["value"]
const _hoisted_15 = ["value"]

import { mapModifires, type typeModifires } from "@/components/utils/modifires";
import {
  withDefaults,
  ref,
  watch,
  Ref,
  computed,
} from "vue";
import {
  FormUnit,
  FormUnitRow,
  FormUnitCell,
  SelectItem,
  ButtonItem,
  PopupWindow,
} from "..";
import {
  RADIO_ETC_DATA_TYPE_LIST,
  RADIO_ETC_TIME_TYPE_LIST,
  RADIO_TRAVOS_HISTORY_LIST,
  dateRanges,
  UPDATE_BUFFER_1HOUR,
  dateRange,
} from "@/components/define/defineType";

interface Props {
  modifires?: typeModifires;
  mapTime?: {
    year: string;
    month: string;
    day: string;
    hour: number;
    minute: number;
  };
  attributeTime?: {
    year: string;
    month: string;
    day: string;
    hour: number;
    minute: number;
  };
  isOpen?: boolean;
  travosHistoryChecked: boolean;
  travosHistoryTimeType: RADIO_TRAVOS_HISTORY_LIST;
  travosHistoryMeasured1HourQ82: boolean;
  travosHistoryMeasured1HourQa82: boolean;
  etcChecked: boolean;
  etcDataType: RADIO_ETC_DATA_TYPE_LIST;
  etcTimeType: RADIO_ETC_TIME_TYPE_LIST;
  dateRangesData: dateRanges;
}
const ONE_DAY = 24 * 60 * 60 * 1000;

export default /*#__PURE__*/_defineComponent({
  __name: 'time-controller',
  props: {
    modifires: { type: [String, Array, Boolean] },
    mapTime: {},
    attributeTime: {},
    isOpen: { type: Boolean },
    travosHistoryChecked: { type: Boolean },
    travosHistoryTimeType: {},
    travosHistoryMeasured1HourQ82: { type: Boolean },
    travosHistoryMeasured1HourQa82: { type: Boolean },
    etcChecked: { type: Boolean },
    etcDataType: {},
    etcTimeType: {},
    dateRangesData: {}
  },
  emits: [
  "executeUpdateTime",
  "updateMapTime",
  "updateAttributeTime",
  "resetMapTime",
],
  setup(__props: any, { emit }) {

const props = __props;





/**
 * 初回処理フラグ
 */
const mountedFlg: Ref<boolean> = ref(false);

/**
 * 地図・属性時間表示時間
 */
const mapTime = ref({
  year: "",
  month: "",
  day: "",
  hour: 0,
  minute: 0,
});

const mapDate: Ref<Date> = ref(null);

/**
 * 属性比較表示時間
 */
const attributeTime = ref({
  year: "",
  month: "",
  day: "",
  hour: 0,
  minute: 0,
});

const attributeDate: Ref<Date> = ref(null);

/**
 * ドラッグエリアスタイル
 */
const dragStyle = ref({
  top: window.document.body.clientHeight - 278 + "px",
  left: "280px",
});

/**
 * TraVoS1時間最新日時
 */
const maxDate1h: Ref<Date> = ref(new Date());

/**
 * ETC種別ラベル
 */
const etcTypeLabel: Ref<string> = ref("");

/**
 * ETC最小日時
 */
const etcMinDate: Ref<Date> = ref(new Date());

/**
 * ETC最大日時
 */
const etcMaxDate: Ref<Date> = ref(new Date());

/**
 * 日時フォーマット定義
 */
const localeOptions: Intl.DateTimeFormatOptions = {
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
  hour: "2-digit",
  minute: "2-digit",
};

/**
 * 初回処理
 */
watch(
  () => props.isOpen,
  () => {
    if (props.isOpen && !mountedFlg.value) {
      updateTime();
      updateEtc();
      // 毎時25分に最大時間を更新
      const nowTime = new Date();
      const nextTime = new Date(
        nowTime.getFullYear(),
        nowTime.getMonth(),
        nowTime.getDate(),
        nowTime.getHours() + 1,
        25
      );
      const delay = nextTime.getTime() - nowTime.getTime();
      setTimeout(() => {
        updateTime();
        setTimeout(() => {
          updateTime();
        }, 60 * 60 * 1000);
      }, delay);

      mountedFlg.value = true;
    }
  }
);

/**
 * props更新
 */
watch(
  () => props.mapTime,
  () => {
    mapTime.value = props.mapTime;
    mapDate.value =
      mapTime.value.year &&
      Number(mapTime.value.month) >= 0 &&
      mapTime.value.day
        ? new Date(
            Number(mapTime.value.year),
            Number(mapTime.value.month) - 1,
            Number(mapTime.value.day)
          )
        : null;
  },
  { deep: true }
);

watch(
  () => props.attributeTime,
  () => {
    attributeTime.value = props.attributeTime;
    attributeDate.value =
      attributeTime.value.year &&
      Number(attributeTime.value.month) >= 0 &&
      attributeTime.value.day
        ? new Date(
            Number(attributeTime.value.year),
            Number(attributeTime.value.month) - 1,
            Number(attributeTime.value.day)
          )
        : null;
  },
  { deep: true }
);

/**
 * 地図・属性時間表示更新
 */
watch(
  () => mapTime.value,
  () => {
    emit("updateMapTime", mapTime.value);
  },
  { deep: true }
);

/**
 * 属性比較表示時間更新
 */
watch(
  () => attributeTime.value,
  () => {
    emit("updateAttributeTime", attributeTime.value);
  },
  { deep: true }
);

/**
 * ETC時間表示更新
 */
watch(
  () => [props.etcDataType, props.etcTimeType],
  () => {
    updateEtc();
  }
);

/**
 * カレンダー選択可能日付
 */
const allowedDateRanges = computed(() => {
  const ranges: dateRange[] = [];

  if (
    props.travosHistoryChecked &&
    props.travosHistoryTimeType == RADIO_TRAVOS_HISTORY_LIST.measured1Hour
  ) {
    if (props.travosHistoryMeasured1HourQ82) {
      ranges.push(props.dateRangesData.travosHistoryMeasured1HourQ82);
    }
    if (props.travosHistoryMeasured1HourQa82) {
      ranges.push(props.dateRangesData.travosHistoryMeasured1HourQa82);
    }
  }

  if (props.etcChecked) {
    ranges.push({
      mindate: etcMinDate.value,
      maxdate: etcMaxDate.value,
    });
  }

  return ranges;
});
const allowedDateSet = ref<Set<number>>(new Set());
watch(
  () => allowedDateRanges.value,
  () => {
    const set = new Set<number>();

    for (const { mindate, maxdate } of allowedDateRanges.value) {
      let current = new Date(
        mindate.getFullYear(),
        mindate.getMonth(),
        mindate.getDate()
      ).getTime();

      const end = new Date(
        maxdate.getFullYear(),
        maxdate.getMonth(),
        maxdate.getDate()
      ).getTime();

      for (; current <= end; current += ONE_DAY) {
        set.add(current);
      }
    }

    allowedDateSet.value = set;
  },
  { immediate: true }
);
const isDisabledDate = (date: Date): boolean => {
  const time = new Date(
    date.getFullYear(),
    date.getMonth(),
    date.getDate()
  ).getTime();
  return !allowedDateSet.value.has(time);
};

/**
 * 地図時間選択時イベント
 */
const selectMapDate = () => {
  mapTime.value.year = mapDate.value?.getFullYear().toString() ?? "";
  mapTime.value.month = mapDate.value
    ? (mapDate.value.getMonth() + 1)?.toString()
    : "";
  mapTime.value.day = mapDate.value?.getDate().toString() ?? "";
  emit("updateMapTime", mapTime.value);
};

/**
 * 属性時間選択時イベント
 */
const selectAttributeDate = () => {
  attributeTime.value.year =
    attributeDate.value?.getFullYear().toString() ?? "";
  attributeTime.value.month = attributeDate.value
    ? (attributeDate.value.getMonth() + 1).toString()
    : "";
  attributeTime.value.day = attributeDate.value?.getDate().toString() ?? "";
  emit("updateAttributeTime", attributeTime.value);
};

/**
 * 時間更新実行
 */
const updateMapTime = () => {
  emit("executeUpdateTime");
};

/**
 * 時間リセット
 */
const resetMapTime = () => {
  mapTime.value = {
    year: "",
    month: "",
    day: "",
    hour: 0,
    minute: 0,
  };
  mapDate.value = null;
  selectMapDate();
  attributeTime.value = {
    year: "",
    month: "",
    day: "",
    hour: 0,
    minute: 0,
  };
  attributeDate.value = null;
  selectAttributeDate();
  emit("resetMapTime");
};

/**
 * ETC表示種別・時間更新
 */
const updateEtc = () => {
  switch (props.etcTimeType) {
    case RADIO_ETC_TIME_TYPE_LIST.day15Minutes:
      if (props.etcDataType == RADIO_ETC_DATA_TYPE_LIST.drmLink) {
        etcTypeLabel.value = "DRMリンク - 日別15分単位";
        etcMinDate.value = props.dateRangesData.etcDrmLinkDay15Minutes.mindate;
        etcMaxDate.value = props.dateRangesData.etcDrmLinkDay15Minutes.maxdate;
      } else {
        etcTypeLabel.value = "交通調査基本区間 - 日別15分単位";
        etcMinDate.value =
          props.dateRangesData.etcBasicSectionDay15Minutes.mindate;
        etcMaxDate.value =
          props.dateRangesData.etcBasicSectionDay15Minutes.maxdate;
      }
      break;
    case RADIO_ETC_TIME_TYPE_LIST.day1Hour:
      if (props.etcDataType == RADIO_ETC_DATA_TYPE_LIST.drmLink) {
        etcTypeLabel.value = "DRMリンク - 日別時間帯別";
        etcMinDate.value = props.dateRangesData.etcDrmLinkDay1Hour.mindate;
        etcMaxDate.value = props.dateRangesData.etcDrmLinkDay1Hour.maxdate;
      } else {
        etcTypeLabel.value = "交通調査基本区間 - 日別時間帯別";
        etcMinDate.value = props.dateRangesData.etcBasicSectionDay1Hour.mindate;
        etcMaxDate.value = props.dateRangesData.etcBasicSectionDay1Hour.maxdate;
      }
      break;
    case RADIO_ETC_TIME_TYPE_LIST.month1Hour:
      if (props.etcDataType == RADIO_ETC_DATA_TYPE_LIST.drmLink) {
        etcTypeLabel.value = "DRMリンク - 月別時間帯別";
        etcMinDate.value = props.dateRangesData.etcDrmLinkMonth1Hour.mindate;
        etcMaxDate.value = props.dateRangesData.etcDrmLinkMonth1Hour.maxdate;
      } else {
        etcTypeLabel.value = "交通調査基本区間 - 月別時間帯別";
        etcMinDate.value =
          props.dateRangesData.etcBasicSectionMonth1Hour.mindate;
        etcMaxDate.value =
          props.dateRangesData.etcBasicSectionMonth1Hour.maxdate;
      }
      break;
  }
};

/**
 * 表示時間更新
 */
const updateTime = () => {
  maxDate1h.value = new Date(
    new Date().getTime() - UPDATE_BUFFER_1HOUR * 60 * 1000
  );
  maxDate1h.value.setMinutes(0);
};

return (_ctx: any,_cache: any) => {
  const _component_VueDatePicker = _resolveComponent("VueDatePicker")!

  return (_openBlock(), _createBlock(_unref(PopupWindow), {
    "data-html2canvas-ignore": "",
    windowId: "timeController",
    width: "594px",
    draggable: true,
    hideHeader: true,
    style: _normalizeStyle(dragStyle.value),
    isOpen: _ctx.isOpen
  }, {
    "main-content": _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(_unref(mapModifires)('time-controller', _ctx.modifires))
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_unref(FormUnit), {
            column: ['114px', '155px', '50px', '50px', '130px'],
            "gap-column": "8px"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _createTextVNode(" 保存期間 "),
                (
                  _ctx.travosHistoryChecked &&
                  _ctx.travosHistoryTimeType ==
                    _unref(RADIO_TRAVOS_HISTORY_LIST).measured1Hour &&
                  _ctx.travosHistoryMeasured1HourQ82
                )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                      _hoisted_4,
                      _createElementVNode("div", _hoisted_5, " ：" + _toDisplayString(props.dateRangesData.travosHistoryMeasured1HourQ82.mindate.toLocaleString(
                      "ja-JP",
                      localeOptions
                    )) + " ~ " + _toDisplayString(maxDate1h.value.toLocaleString("ja-JP", localeOptions)), 1)
                    ]))
                  : _createCommentVNode("", true),
                (
                  _ctx.travosHistoryChecked &&
                  _ctx.travosHistoryTimeType ==
                    _unref(RADIO_TRAVOS_HISTORY_LIST).measured1Hour &&
                  _ctx.travosHistoryMeasured1HourQa82
                )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _hoisted_7,
                      _createElementVNode("div", _hoisted_8, " ：" + _toDisplayString(props.dateRangesData.travosHistoryMeasured1HourQa82.mindate.toLocaleString(
                      "ja-JP",
                      localeOptions
                    )) + " ~ " + _toDisplayString(maxDate1h.value.toLocaleString("ja-JP", localeOptions)), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.etcChecked)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, "ETC2.0 - " + _toDisplayString(etcTypeLabel.value), 1),
                      _createElementVNode("div", _hoisted_11, " ：" + _toDisplayString(etcMinDate.value.toLocaleString("ja-JP", localeOptions)) + " ~ " + _toDisplayString(etcMaxDate.value.toLocaleString("ja-JP", localeOptions)), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createVNode(_unref(FormUnitRow), { align: "right" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(FormUnitCell)),
                  _createVNode(_unref(FormUnitCell), null, {
                    default: _withCtx(() => [
                      _createTextVNode("年 月 日")
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(FormUnitCell), null, {
                    default: _withCtx(() => [
                      _createTextVNode("時")
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(FormUnitCell), null, {
                    default: _withCtx(() => [
                      _createTextVNode("分")
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(FormUnitCell))
                ]),
                _: 1
              }),
              _createVNode(_unref(FormUnitRow), null, {
                default: _withCtx(() => [
                  _createVNode(_unref(FormUnitCell), null, {
                    default: _withCtx(() => [
                      _createTextVNode("地図・属性表示対象")
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(FormUnitCell), null, {
                    default: _withCtx(() => [
                      _createVNode(_component_VueDatePicker, {
                        class: "date-picker",
                        locale: "jp",
                        "text-input": "",
                        "auto-apply": "",
                        "six-weeks": "",
                        "enable-time-picker": false,
                        "disabled-dates": isDisabledDate,
                        format: "yyyy/MM/dd",
                        title: "月別での指定でも日までご指定ください",
                        modelValue: mapDate.value,
                        "onUpdate:modelValue": [
                          _cache[0] || (_cache[0] = ($event: any) => ((mapDate).value = $event)),
                          selectMapDate
                        ]
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(FormUnitCell), null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(SelectItem), {
                        value: mapTime.value.hour.toString(),
                        onUpdate: _cache[1] || (_cache[1] = 
                    (value) => {
                      mapTime.value.hour = Number(value);
                    }
                  )
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(24, (n) => {
                            return _createElementVNode("option", {
                              key: n - 1,
                              value: (n - 1).toString()
                            }, _toDisplayString(n - 1), 9, _hoisted_12)
                          }), 64))
                        ]),
                        _: 1
                      }, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(FormUnitCell), null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(SelectItem), {
                        value: mapTime.value.minute.toString(),
                        onUpdate: _cache[2] || (_cache[2] = 
                    (value) => {
                      mapTime.value.minute = Number(value);
                    }
                  )
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, (n) => {
                            return _createElementVNode("option", {
                              key: (n - 1) * 15,
                              value: ((n - 1) * 15).toString()
                            }, _toDisplayString((n - 1) * 15), 9, _hoisted_13)
                          }), 64))
                        ]),
                        _: 1
                      }, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(FormUnitCell), { align: "right" }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(ButtonItem), { onClick: updateMapTime }, {
                        default: _withCtx(() => [
                          _createTextVNode("実行")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_unref(FormUnitRow), null, {
                default: _withCtx(() => [
                  _createVNode(_unref(FormUnitCell), null, {
                    default: _withCtx(() => [
                      _createTextVNode("属性比較表示対象")
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(FormUnitCell), null, {
                    default: _withCtx(() => [
                      _createVNode(_component_VueDatePicker, {
                        class: "date-picker",
                        locale: "jp",
                        "text-input": "",
                        "auto-apply": "",
                        "six-weeks": "",
                        "enable-time-picker": false,
                        "disabled-dates": isDisabledDate,
                        format: "yyyy/MM/dd",
                        title: "月別での指定でも日までご指定ください",
                        modelValue: attributeDate.value,
                        "onUpdate:modelValue": [
                          _cache[3] || (_cache[3] = ($event: any) => ((attributeDate).value = $event)),
                          selectAttributeDate
                        ]
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(FormUnitCell), null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(SelectItem), {
                        value: attributeTime.value.hour.toString(),
                        onUpdate: _cache[4] || (_cache[4] = 
                    (value) => {
                      attributeTime.value.hour = Number(value);
                    }
                  )
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(24, (n) => {
                            return _createElementVNode("option", {
                              key: n - 1,
                              value: (n - 1).toString()
                            }, _toDisplayString(n - 1), 9, _hoisted_14)
                          }), 64))
                        ]),
                        _: 1
                      }, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(FormUnitCell), null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(SelectItem), {
                        value: attributeTime.value.minute.toString(),
                        onUpdate: _cache[5] || (_cache[5] = 
                    (value) => {
                      attributeTime.value.minute = Number(value);
                    }
                  )
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, (n) => {
                            return _createElementVNode("option", {
                              key: (n - 1) * 15,
                              value: ((n - 1) * 15).toString()
                            }, _toDisplayString((n - 1) * 15), 9, _hoisted_15)
                          }), 64))
                        ]),
                        _: 1
                      }, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(FormUnitCell), { align: "right" }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(ButtonItem), {
                        onClick: resetMapTime,
                        negative: true
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("リセット")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ], 2)
    ]),
    _: 1
  }, 8, ["style", "isOpen"]))
}
}

})